{
  "login": {
    "heading": "Sign in",
    "intro": "This record is used when the central EHR is unavailable. Sign in with your demo account.",
    "username": "Username",
    "password": "Password",
    "submit": "Sign in",
    "submitting": "Signing in …",
    "missing": "Enter both a username and a password."
  },
  "refusal": {
    "invalidCredentials": "Wrong username or password.",
    "unknown": "The sign-in was refused. Check the username and password and try again.",
    "unavailable": "The system is not responding. Contact the on-call technician — document on paper meanwhile.",
    "roleMayNotDocument": "You are signed in as {role} and can read the record but not document in it."
  },
  "role": {
    "physician": "Physician",
    "nurse": "Nurse"
  },
  "signedInAs": "{name} ({role})",
  "session": {
    "logout": "Sign out",
    "expired": "You have been signed out. Sign in again to continue."
  }
}
